import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home } from 'lucide-react';
import { GradientButton } from '../components/ui';
import PageMeta from '../components/PageMeta';

export default function NotFound() {
  return (
    <>
      <PageMeta title="404 — Nathan Victorin" />
      <div className="min-h-screen flex items-center justify-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <p className="text-8xl font-black gradient-text mb-4">404</p>
          <h1 className="text-2xl font-bold text-ink mb-2">Page introuvable</h1>
          <p className="text-zinc-500 mb-8">Cette page n'existe pas ou a été déplacée.</p>
          <Link to="/">
            <GradientButton><Home size={16} className="inline mr-2" />Retour à l'accueil</GradientButton>
          </Link>
        </motion.div>
      </div>
    </>
  );
}
